import React, { useState } from 'react';
import Switch from '../../../Components/switch';
import ModalEdit from '../Components/ModalEdit';
import Modal from '../../../Components/Modal';
import Alert from '../../../Components/Alert';
import useTranslation from '../../../Hooks/useTranslation';

const useComponent = ({ employees, setEmployees }) => {
  const { t } = useTranslation();

  const thereIsComponent = (data, index) => {
    if (index === 6) {
      const [active, setActive] = useState(data[index] === t('Generic.Active'));
      const [openModal, setOpenModal] = useState(false);
      const [openAlert, setOpenAlert] = useState(false);

      return (
        <div>
          <Switch active={active} event={() => setOpenModal(true)} />
          <Modal
            open={openModal}
            setOpen={setActive}
            Children={
              <ModalEdit
                data={data}
                cancel={() => {
                  setOpenModal(!openModal);
                }}
                accept={() => {
                  setActive(!active);
                  setOpenModal(!openModal);
                  setOpenAlert(true);
                }}
                allEmployees={employees}
                setAllEmployees={setEmployees}
              />
            }
          />
          <Alert message={t('Employee.AlertTitle')} open={openAlert} setOpen={setOpenAlert} />
        </div>
      );
    }
    return data[index];
  };

  return {
    thereIsComponent,
  };
};

export default useComponent;
